var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("渠道列表")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("渠道列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "来源渠道", prop: "val1" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: _vm.ruleForm2.val1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "val1", $$v)
                                      },
                                      expression: "ruleForm2.val1",
                                    },
                                  },
                                  _vm._l(
                                    _vm.sourseList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.key,
                                          value: item.val,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-form-item", { attrs: { label: "时间" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "选择开始时间",
                                      align: "right",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.ruleForm2.time,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "time", $$v)
                                      },
                                      expression: "ruleForm2.time",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { margin: "0 5px" } },
                                    [_vm._v("-")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "选择结束时间",
                                      align: "right",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.ruleForm2.time1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "time1", $$v)
                                      },
                                      expression: "ruleForm2.time1",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.orgList },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "equipmentKey",
                    label: "设备码",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "sourceFrom",
                    label: "来源渠道",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.sourceFrom == 1
                            ? _c("span", [_vm._v("咖德")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.sourceFrom == 2
                            ? _c("span", [_vm._v("西安")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.sourceFrom == 3
                            ? _c("span", [_vm._v("微博")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.sourceFrom == 4
                            ? _c("span", [_vm._v("微信/公众号")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.sourceFrom == 5
                            ? _c("span", [_vm._v("小红书")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.sourceFrom == 6
                            ? _c("span", [_vm._v("抖音")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalType",
                    label: "App端",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.terminalType == 1
                            ? _c("span", [_vm._v("客户端")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.terminalType == 2
                            ? _c("span", [_vm._v("保安端")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "province",
                    label: "人员类型",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "创建时间",
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }